import React, { Component } from 'react'
import Mesh from 'aria-viewer/players/three/Mesh'
import DomEvents from '../../../utils/domevents'
import * as THREE from 'three'
import { dispose3DObject } from '../../../utils'

var material = new THREE.MeshBasicMaterial()

class HitMesh3D extends Component {
    constructor(props) {
        super(props)
    }

    state = {
        obj: null,
        domEvents: null,
    }

    // componentDidMount() {
    //     this.setState({
    //         material,
    //         geometry,
    //     })
    // }

    // componentDidUpdate(prevProps) {
    //     const { origScale, obj } = this.state
    //     const { parentScale, maintainScale } = this.props
    //     if (parentScale && maintainScale && !origScale) {
    //         this.setState({ origScale: Object.assign({}, parentScale) })
    //     }
    // }

    initializeInteractionCallbacks = obj => {
        const {
            camera,
            renderer,
            handleClick,
            handleTouchStart,
            handleTouchEnd,
            handleMouseOver,
            handleMouseOut,
            isMobile,
            enableGaze,
        } = this.props

        if (handleClick || handleMouseOver || handleMouseOut || handleTouchStart || handleTouchEnd) {
            let domEvents = new DomEvents(camera, renderer.domElement)

            handleClick &&
                !isMobile &&
                domEvents.addEventListener(obj, 'click', handleClick, false, { touchRelativeToViewport: true })

            handleTouchStart &&
                isMobile &&
                domEvents.addEventListener(obj, 'touchstart', handleTouchStart, false, {
                    touchRelativeToViewport: true,
                })

            isMobile &&
                (handleMouseOver || handleTouchStart) &&
                enableGaze &&
                domEvents.addEventListener(obj, 'gazeover', handleMouseOver, false, {
                    touchRelativeToViewport: true,
                })

            isMobile &&
                (handleMouseOut || handleTouchEnd) &&
                enableGaze &&
                domEvents.addEventListener(obj, 'gazeexit', handleMouseOut, false, {
                    touchRelativeToViewport: true,
                })

            handleTouchEnd &&
                isMobile &&
                domEvents.addEventListener(obj, 'touchend', handleTouchEnd, false, { touchRelativeToViewport: true })

            handleMouseOver &&
                !isMobile &&
                domEvents.addEventListener(obj, 'mouseover', handleMouseOver, false, { touchRelativeToViewport: true })

            handleMouseOut &&
                !isMobile &&
                domEvents.addEventListener(obj, 'mouseout', handleMouseOut, false, { touchRelativeToViewport: true })

            this.setState({ domEvents })
        }
    }

    onMeshMount = obj => {
        const {
            height,
            width,
            radius,
            rootObj,
            opacity,
            geometry,
            segments,
            color,
            depthOffset,
            renderOrder,
        } = this.props
        // Sets on object
        // Uses presence of radius prop to determine if area of geometry is based on radial measurements or height/width
        obj.geometry = radius ? new geometry(radius, segments) : new geometry(width, height, segments)

        // Identify hit meshes so that QA can grab them
        obj.name = 'HitMesh'

        obj.material.color = new THREE.Color(color)

        // Set to allow for opacity to work
        obj.material.transparent = true
        obj.material.opacity = opacity

        // if (renderOrder) {
        //     obj.material.depthTest = false
        //     obj.renderOrder = renderOrder
        //     obj.onBeforeRender = function( renderer ) { renderer.clearDepth(); };
        // }

        // Add to root object
        rootObj.add(obj)

        if (depthOffset) {
            obj.position.set(0, 0, depthOffset)
        }
        // Sets small timeout so that hover enters aren't accidentally triggered before they're translated into position in space
        // https://youvisit.atlassian.net/secure/RapidBoard.jspa?rapidView=76&modal=detail&selectedIssue=AV-182
        this.callbackTimeout = setTimeout(() => {
            this.initializeInteractionCallbacks(obj)
        }, 250)

        // Sets resources on state
        this.setState({ obj })
    }

    onMeshUnmount = () => {
        const { rootObj } = this.props
        const { obj, domEvents } = this.state
        domEvents && domEvents.destroy()
        dispose3DObject(obj)
        rootObj.remove(obj)
        // scene.remove(obj)
        // scene.remove(rootObj)
        if (obj.mesh) {
            obj.geometry.dispose()
            obj.geometry = undefined
        }
        if (obj.texture) {
            obj.texture.dispose()
            obj.texture = undefined
        }
        if (obj.geometry) {
            obj.geometry.dispose()
            obj.geometry = undefined
        }
        if (obj.material) {
            if (obj.material.map) {
                obj.material.map.dispose()
                obj.material.map = undefined
            }
            obj.material.dispose()
            obj.material = undefined
        }
        if (rootObj.mesh) {
            rootObj.geometry.dispose()
            rootObj.geometry = undefined
        }
        if (rootObj.texture) {
            rootObj.texture.dispose()
            rootObj.texture = undefined
        }
        if (rootObj.geometry) {
            rootObj.geometry.dispose()
            rootObj.geometry = undefined
        }
        if (obj.material) {
            if (rootObj.material.map) {
                rootObj.material.map.dispose()
                rootObj.material.map = undefined
            }
            rootObj.material.dispose()
            rootObj.material = undefined
        }
        this.setState({ obj: null, domEvents: null })
    }

    componentWillUnmount = () => {
        const { rootObj } = this.props
        const { obj, domEvents } = this.state
        domEvents && domEvents.destroy()
        dispose3DObject(obj)
        clearTimeout(this.callbackTimeout)
        rootObj.remove(obj)
        this.setState({ obj: null, domEvents: null })
    }

    render() {
        const { geometry } = this.props
        return geometry ? (
            <Mesh
                geometry={geometry}
                material={material}
                onMount={this.onMeshMount}
                onWillUnmount={this.onMeshUnmount}
            />
        ) : null
    }
}

HitMesh3D.defaultProps = {
    width: null,
    height: null,
    radius: null,
    opacity: 0,
    segments: 32,
    color: 0x000000,
    geometryClass: THREE.PlaneGeometry,
}

export default HitMesh3D
